function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormgroupExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.96 111.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EXPERTEN"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.5 83.4 48.48 111.1 96.47 83.4 96.46 27.99 48.48 0.29 0.5 27.99 0.5 83.4",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,83.52l48-27.82m0,0L48.48.29m.15,55.41L96.17,83.29",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.76,87.68c-1.25-5.33-4-13.57-9.28-16.72l-3.15-1.88L54,65.55a9.41,9.41,0,0,0,.9-.52l0,0,.11-.08a3.2,3.2,0,0,0,1.52-2.15L57,60.94l1.45-6.48a6.21,6.21,0,0,0,.14-.62l0-.17h0a10.64,10.64,0,0,0,.14-1.56c.07-5.68-3.84-12.64-8.73-15.54-2.24-1.32-4.08-1.64-5.65-1l-.22.07-.12.07a3.39,3.39,0,0,0-.53.29L39.35,38.3l-.22.46,2,1.52a9.33,9.33,0,0,0-.1,1.33,10.85,10.85,0,0,0,.05,1.5l0,.13,0,.35c0,.31.08.48.14.79l1.64,10.33h0a16.32,16.32,0,0,0,2.5,6.15L45,63.66c-.77-.46-2.15-1.36-3.15-2-2.07-1.23-3.59-1.3-5-.62l-.19.07-.48.27h0l-3.62,2,.81,1.31a19.93,19.93,0,0,0-1.1,2.49c-.62,1.74.68,4.69,2.58,5.81L49.2,81.54l.62.37,11.06,6.56c.15,1.33.38,3.12.5,4a.44.44,0,0,0,.64.32l4-2.25h0C66.77,90.19,67.1,89.13,66.76,87.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,93.27a.81.81,0,0,1-.37-.09.82.82,0,0,1-.44-.61c-.11-.89-.33-2.56-.48-3.87L34.68,73.38c-2-1.21-3.42-4.37-2.74-6.26a20.45,20.45,0,0,1,1-2.36l-.91-1.46,4.68-2.58c1.58-.76,3.28-.56,5.32.65.54.32,1.19.73,1.79,1.11l.88.56L45,61a16.43,16.43,0,0,1-2.47-6.19L40.88,44.22c0-.19-.07-.35-.1-.58l-.06-.44a10.1,10.1,0,0,1-.06-1.6,9.41,9.41,0,0,1,.08-1.15l-2.09-1.58.41-.84,4.24-2.34a3.71,3.71,0,0,1,.56-.31l.09-.05.29-.1c1.66-.71,3.62-.38,6,1,5,2.95,9,10.07,8.92,15.87a10.9,10.9,0,0,1-.1,1.36h0l-.08.44c0,.21-.09.43-.15.64l-1.87,8.31a3.64,3.64,0,0,1-1.68,2.38l-.1.07c-.27.18-.52.32-.76.45l.3,3.08,3,1.78c5.25,3.12,8,11,9.45,17,.37,1.53,0,2.81-.89,3.32l-4,2.25A.85.85,0,0,1,61.81,93.27ZM33.13,63.58l.71,1.15-.1.2a19.51,19.51,0,0,0-1.08,2.44c-.56,1.57.67,4.32,2.41,5.35L61.24,88.24l0,.19c.15,1.32.38,3.11.5,4l4.1-2.21c.6-.34.81-1.31.53-2.49h0c-1.13-4.81-3.81-13.34-9.1-16.48l-3.32-2-.39-4,.24-.11c.28-.14.57-.31.86-.49l.13-.1a2.84,2.84,0,0,0,1.38-1.91l1.87-8.33c.06-.21.1-.41.14-.61l0-.17a8.91,8.91,0,0,0,.14-1.5c.07-5.55-3.77-12.38-8.55-15.21-2.11-1.25-3.85-1.57-5.31-1l-.3.12a4.86,4.86,0,0,0-.51.28l-4.08,2.3,1.94,1.47,0,.22a8.54,8.54,0,0,0-.1,1.28,10,10,0,0,0,0,1.46l0,.09,0,.39c0,.2.06.35.09.52l0,.24,1.64,10.34a15.8,15.8,0,0,0,2.44,6l.08.12-.52,3.51L44.83,64l-1.38-.86c-.6-.38-1.24-.78-1.78-1.1-1.83-1.09-3.25-1.28-4.61-.61l-.21.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE",
    d: "M62.33,90.16c-1.26-5.33-4-13.58-9.29-16.72l-3.15-1.88L49.55,68a4.14,4.14,0,0,0,2.57-2.76l.42-1.85L54,56.94c0-.21.1-.41.14-.63l0-.16h0a9.52,9.52,0,0,0,.14-1.56c.07-5.68-3.84-12.64-8.73-15.54s-8.9-.64-9,5a10.94,10.94,0,0,0,0,1.51l0,.13,0,.35a7.27,7.27,0,0,0,.14.79L38.5,57.19h0A16.39,16.39,0,0,0,41,63.34l-.41,2.8c-.77-.46-2.15-1.37-3.16-2-5.32-3.15-8.2,1.76-9.56,5.54-.63,1.74.67,4.68,2.57,5.81L44.76,84l.62.37,14.27,8.46C61.55,94,62.9,92.61,62.33,90.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.92,93.63a2.87,2.87,0,0,1-1.46-.45L30.25,75.85c-2-1.2-3.42-4.36-2.74-6.26C28.39,67.13,30,64,32.6,63.07a5.8,5.8,0,0,1,5,.78L39.4,65l.89.56.32-2.08a16.75,16.75,0,0,1-2.48-6.19L36.45,46.69c0-.19-.07-.34-.1-.57l-.07-.44a11.5,11.5,0,0,1-.06-1.6c0-2.89,1.05-5,2.87-6.07s4.19-.77,6.68.7c5,3,9,10.08,8.91,15.88a10.74,10.74,0,0,1-.1,1.35h0l-.09.45c0,.21-.09.42-.14.63l-1.88,8.32A4.34,4.34,0,0,1,50,68.25l.3,3.08,3,1.78c5.26,3.12,8,11,9.46,17h0c.33,1.44.06,2.64-.72,3.22A1.74,1.74,0,0,1,60.92,93.63ZM34.21,63.55a3.84,3.84,0,0,0-1.35.24c-2.33.83-3.81,3.76-4.64,6.06-.56,1.57.68,4.32,2.41,5.35L59.85,92.52a1.51,1.51,0,0,0,1.68.16A2.38,2.38,0,0,0,62,90.25c-1.13-4.81-3.82-13.35-9.11-16.48l-3.32-2-.38-4,.23-.12a3.79,3.79,0,0,0,2.37-2.5l1.87-8.33c.06-.2.1-.4.14-.6l0-.17a10,10,0,0,0,.13-1.5C54,49,50.15,42.2,45.38,39.37,43.14,38,41,37.79,39.46,38.68S37,41.48,37,44.09A10,10,0,0,0,37,45.55l0,.08,0,.4c0,.2.06.34.09.51l.05.25,1.64,10.34a15.93,15.93,0,0,0,2.44,6l.08.12-.52,3.5-.49-.29c-.36-.21-.86-.53-1.39-.86s-1.23-.78-1.76-1.09A6,6,0,0,0,34.21,63.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.78 52.86 58.45 49.01 54 51.5 54.51 54.17 52.52 63.78 52.4 63.86 51.89 65.93 50.24 67.75 49.55 68.02 49.89 71.56 54.33 69.08 53.99 65.55 55.99 64.41 56.67 62.08 56.91 61.27 58.78 52.86",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.28 86.28 65.55 83.74 66.7 86.91 66.86 88.9 66.51 90.42 62.02 92.83 62.46 90.97 61.58 87.04 61.28 86.28",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,49.45c0-5.51-4.13-12.29-9-14.48-1.81-.81-3.31-.89-4.57-.21l-.15.08h0l0,0-4,2.33a.37.37,0,0,0-.11.52L65.66,40c-.06,3.94,2,8.57,5,11.7V55c0,.62.63,1.31,1,1.13l2.67-1.21,1,1.72a.4.4,0,0,0,.54.15l3.54-2.07h0C80.91,53.86,81.83,52.05,81.83,49.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.68,57.2a.64.64,0,0,1-.2,0,.74.74,0,0,1-.47-.36l-.79-1.42-2.35,1.06a.83.83,0,0,1-.81-.1A1.73,1.73,0,0,1,70.3,55V51.81a18.25,18.25,0,0,1-5-11.72l-1.58-2.16a.71.71,0,0,1-.13-.58.73.73,0,0,1,.35-.49l4.17-2.44c1.35-.73,3-.67,4.89.2,4.92,2.21,9.24,9.15,9.24,14.83,0,2.55-.85,4.48-2.4,5.46h0l-.19.12-3.55,2.06A.77.77,0,0,1,75.68,57.2Zm-1.14-2.79,1.13,2,3.57-2.07c1.42-.8,2.21-2.54,2.21-4.91,0-5.42-4.11-12-8.79-14.13-1.71-.77-3.09-.84-4.23-.22l-.16.08-4,2.34L66,39.84V40C66,43.66,68,48.26,71,51.4l.1.11V55a.91.91,0,0,0,.51.77Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,51.72c0-5.51-4.13-12.29-9-14.48-3.63-1.64-6.61,0-7.09,3.92-.51,4.15,1.69,9.35,5,12.77v3.32c0,.61.63,1.31,1,1.12L71,56.94C74.9,58.58,77.93,56.44,77.93,51.72Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,58.79a.94.94,0,0,1-.51-.17,1.73,1.73,0,0,1-.76-1.37V54.08c-3.41-3.64-5.45-8.95-5-13A5.5,5.5,0,0,1,64,36.8a5.62,5.62,0,0,1,5.11.09C74,39.1,78.31,46,78.31,51.72c0,2.49-.83,4.41-2.33,5.41a5.31,5.31,0,0,1-5,.23l-3,1.36A.82.82,0,0,1,67.67,58.79ZM66.24,37a3.78,3.78,0,0,0-1.9.48A4.7,4.7,0,0,0,62.2,41.2c-.47,3.85,1.53,9,4.85,12.47l.11.11v3.47a.92.92,0,0,0,.51.77L71,56.53l.15.06a4.65,4.65,0,0,0,4.45-.09c1.28-.85,2-2.55,2-4.78,0-5.42-4.11-12-8.79-14.14A6.27,6.27,0,0,0,66.24,37Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.22 47.51 81.15 45.22 81.83 47.25 81.83 50.68 81.45 52.5 78.57 55.33 76.25 56.43 77.93 53.05 77.93 49.45 77.22 47.51",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-2",
    "data-name": "ACTIVE",
    d: "M67.1,46c0,.9-.63,1.26-1.4.81a3.08,3.08,0,0,1-1.41-2.43c0-.89.63-1.26,1.41-.81A3.12,3.12,0,0,1,67.1,46Zm2.5-.14c-.78-.45-1.41-.09-1.41.81a3.11,3.11,0,0,0,1.41,2.43c.77.45,1.4.08,1.4-.81A3.09,3.09,0,0,0,69.6,45.89Zm3.9,2.21c-.77-.45-1.4-.09-1.4.81a3.09,3.09,0,0,0,1.4,2.43c.78.45,1.41.09,1.41-.81A3.11,3.11,0,0,0,73.5,48.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32,47.28a1.52,1.52,0,0,1-.75-.22A3.34,3.34,0,0,1,64,44.41a1.11,1.11,0,0,1,1.78-1A3.36,3.36,0,0,1,67.35,46a1.25,1.25,0,0,1-.53,1.13A1.06,1.06,0,0,1,66.32,47.28Zm-1.25-3.62a.48.48,0,0,0-.24.06.75.75,0,0,0-.28.69,2.86,2.86,0,0,0,1.27,2.21.77.77,0,0,0,.74.1.78.78,0,0,0,.29-.69,2.89,2.89,0,0,0-1.28-2.22A1.05,1.05,0,0,0,65.07,43.66Zm9.06,8.13a1.51,1.51,0,0,1-.75-.23,3.33,3.33,0,0,1-1.54-2.65,1.22,1.22,0,0,1,.54-1.13,1.24,1.24,0,0,1,1.25.1,3.34,3.34,0,0,1,1.53,2.65,1.22,1.22,0,0,1-.54,1.13A.92.92,0,0,1,74.13,51.79Zm-1.26-3.63a.41.41,0,0,0-.23.06.76.76,0,0,0-.29.69,2.88,2.88,0,0,0,1.28,2.21.74.74,0,0,0,.74.1.75.75,0,0,0,.28-.69,2.86,2.86,0,0,0-1.27-2.21A1.15,1.15,0,0,0,72.87,48.16Zm-2.64,1.38a1.55,1.55,0,0,1-.76-.23,3.32,3.32,0,0,1-1.53-2.65,1.11,1.11,0,0,1,1.79-1,3.35,3.35,0,0,1,1.53,2.65,1.22,1.22,0,0,1-.54,1.13A1.05,1.05,0,0,1,70.23,49.54ZM69,45.91a.48.48,0,0,0-.24.06.75.75,0,0,0-.28.69,2.85,2.85,0,0,0,1.28,2.21.61.61,0,0,0,1-.59,2.88,2.88,0,0,0-1.28-2.21A1,1,0,0,0,69,45.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.38,95.7c.28.16.28.41,0,.57a1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,56.38,95.7Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,94.19a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,59,94.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.78,94.19a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,53.78,94.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.38,92.69c.28.16.28.41,0,.57a1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,56.38,92.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17,92.69a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,51.17,92.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.28,
    cy: 91.47,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.06,
    cy: 91.47,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17,89.68a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,51.17,89.68Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.46,
    cy: 89.97,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.56,88.17a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,48.56,88.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.33,88.16a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,43.33,88.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.93,86.65a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,45.93,86.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.72,86.65a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,40.72,86.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.33,85.15a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,43.33,85.15Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.62,
    cy: 85.44,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.72,83.64a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,40.72,83.64Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51,83.64a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,35.51,83.64Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.12,82.14a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.1,1.1,0,0,1,38.12,82.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,82.14c.28.16.28.41,0,.57a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.08,1.08,0,0,1,32.9,82.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.01,
    cy: 80.92,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,80.63a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,30.3,80.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,79.13c.28.16.28.42,0,.57a1.08,1.08,0,0,1-1,0c-.28-.15-.28-.41,0-.57A1.08,1.08,0,0,1,32.9,79.13Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.69,79.13c.28.16.28.42,0,.57a1.1,1.1,0,0,1-1,0c-.27-.15-.27-.41,0-.57A1.1,1.1,0,0,1,27.69,79.13Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,77.62a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.17,1.17,0,0,1,30.3,77.62Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.69,76.12c.28.16.28.42,0,.57a1.1,1.1,0,0,1-1,0c-.27-.15-.27-.41,0-.57A1.1,1.1,0,0,1,27.69,76.12Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,97a.31.31,0,0,1,0,.58,1.15,1.15,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,64.3,97Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,95.46c.27.15.27.41,0,.57a1.1,1.1,0,0,1-1,0c-.27-.16-.27-.42,0-.57A1.1,1.1,0,0,1,66.91,95.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,94a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,69.51,94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.09,97a.31.31,0,0,1,0,.58,1.17,1.17,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,59.09,97Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,95.46c.27.15.27.41,0,.57a1.1,1.1,0,0,1-1,0c-.28-.16-.28-.42,0-.57A1.1,1.1,0,0,1,61.7,95.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,94a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,64.3,94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,92.45a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,66.91,92.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,90.94a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,69.51,90.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.48.29.5,28l48,27.71L96.46,28Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L.5,28V83.4l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormgroupExpert);
export default __webpack_public_path__ + "static/media/formgroup_expert.5f2e23a53e87dcdffc31d2a7cc310e97.svg";
export { ForwardRef as ReactComponent };